<template>
  <div id='five'>
    <img src="../../assect/500.jpg">
    <div class="advance" @click="advance">
        <img src="../../assect/rocket.png" alt=""/>
        <p>回到首页</p>
    </div>
  </div>
</template>
<script>

export default {
    methods: {
        advance(){
            this.$router.push('home');
        }
    }
};
</script>
<style lang="less">
body{
    background-color:#fff;
    margin:0;
}
#five{
    img{
        width:100%;
        height:100%;
    }
    .advance{
        position:fixed;
        bottom:10vw;
        right:10vw;
        p{
            position:relative;
            left:-1.4vw;
        }
    }
}
</style>

